module.exports = __webpack_public_path__ + "img/plus-circle.142e9330.svg";